import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-bootstrap'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_PendingApprovalAdviserProfileBlurbEditor.scss'
import * as blurbStyles from '../../../../../common/AdviserProfiles/AdviserProfileBlurb/_AdviserProfileBlurb.scss'
import FieldGroup from '../../../../../common/forms/FieldGroup'
import FieldGroupTextArea from '../../../../../common/forms/FieldGroupTextArea'
import { connect } from 'react-redux'
import {
  startEditingBlurb
  , stopEditingBlurb
  , setAdviserCompany
  , setAdviserFirstName
  , setAdviserMiddleName
  , setAdviserLastName
  , setAdviserTitle
  , setAdviserCompanyWebsite
  , setAdviserBuildingDetails
  , setAdviserStreetAddress
  , setAdviserSuburb
  , setAdviserPostalCode
  , setAdviserCity
  , setAdviserDescription
  , cancelEditingAdviserProfileBlurb
} from './pendingApprovalAdviserProfileBlurbEditorActions'
import { bindActionCreators } from 'redux'

class PendingApprovalAdviserProfileBlurbEditor extends React.Component {
  static propTypes = {
    pendingApprovalProfile: PropTypes.object.isRequired,
    publishedProfile: PropTypes.object.isRequired,
    editing: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    startEditing: PropTypes.func.isRequired,
    stopEditing: PropTypes.func.isRequired,
    setAdviserFirstName: PropTypes.func.isRequired,
    setAdviserMiddleName: PropTypes.func.isRequired,
    setAdviserLastName: PropTypes.func.isRequired,
    setAdviserTitle: PropTypes.func.isRequired,
    setAdviserCompany: PropTypes.func.isRequired,
    setAdviserCompanyWebsite: PropTypes.func.isRequired,
    setAdviserBuildingDetails: PropTypes.func.isRequired,
    setAdviserStreetAddress: PropTypes.func.isRequired,
    setAdviserSuburb: PropTypes.func.isRequired,
    setAdviserPostalCode: PropTypes.func.isRequired,
    setAdviserCity: PropTypes.func.isRequired,
    setAdviserDescription: PropTypes.func.isRequired,
    cancelEditingAdviserProfileBlurb: PropTypes.func.isRequired,
    formIsValid: PropTypes.bool.isRequired,
    validationstate: PropTypes.object.isRequired,
    children: PropTypes.oneOfType([
      PropTypes.node, 
      PropTypes.arrayOf(PropTypes.node)
    ]),
    editingProfile: PropTypes.bool.isRequired
  };

  componentDidMount () {
    this.setState({})
  }

  constructor (props) {
    super(props)
    this.renderPreview = this.renderPreview.bind(this)
    this.renderEditor = this.renderEditor.bind(this)
    this.handleTitleChange = this.handleTitleChange.bind(this)
    this.handleCompanyChange = this.handleCompanyChange.bind(this)
    this.handleFirstNameChange = this.handleFirstNameChange.bind(this)
    this.handleMiddleNameChange = this.handleMiddleNameChange.bind(this)
    this.handleLastNameChange = this.handleLastNameChange.bind(this)
    this.handleBuildingDetailsChange = this.handleBuildingDetailsChange.bind(this)
    this.handleStreetAddressChange = this.handleStreetAddressChange.bind(this)
    this.handleSuburbChange = this.handleSuburbChange.bind(this)
    this.handlePostalCodeChange = this.handlePostalCodeChange.bind(this)
    this.handleCityChange = this.handleCityChange.bind(this)
  }

  renderPreview (profile, oldProfile) {
    let website = profile.companyWebsite
    if (profile.companyWebsite && profile.companyWebsite.indexOf('http://') < 0 && profile.companyWebsite.indexOf('https://') < 0) {
      website = `http://${website}`
    }
    let jobTitle = ''
    if (profile.title) {
      jobTitle += profile.title
    }
    if (profile.company) {
      jobTitle += ' at ' + profile.company
    }

    var modifiedClass = styles['field-was-modified']
    var webSiteModified = profile.companyWebsite !== oldProfile.companyWebsite
    var companyAddressModified = profile.companyAddress !== oldProfile.companyAddress
    var blurbModified = profile.blurb !== oldProfile.blurb
    var titleModified = profile.title !== oldProfile.title
    var adviserNameModified = profile.adviserName !== oldProfile.adviserName

    // adviserFullName is for display only - do NOT assign it back onto `profile` (that is
    // live Redux state; the in-place write tripped Redux Toolkit's immutability check and
    // crashed the editor on save). adviserName is kept in sync in the blurb reducer instead.
    var adviserFullName = profile.firstName + ' ' + profile.lastName
    let physicalAddress = profile.streetAddress + ' ' + profile.suburb + ' ' + profile.city + ' ' + profile.postalCode

    return (
      <div>
        <Row>
          <Col sm={9} md={9} lg={9} className="d-none d-sm-block">
            <h2 className={styles['adviser-name'] + ' ' + (adviserNameModified ? modifiedClass : '')}>{adviserFullName}</h2>
          </Col>
          <Col sm={3} md={3} lg={3} className="d-none d-sm-block">
            {this.props.children}
          </Col>
        </Row>
        <div className={styles['adviser-job-title'] + ' ' + (titleModified ? modifiedClass : '')}> {jobTitle} </div>
        <div>
          <a
            className={styles['adviser-company-website'] + ' ' + (webSiteModified ? modifiedClass : '')}
            href={website}
            target='blank'>
            {profile.companyWebsite}
          </a>
        </div>
        <div
          className={styles['adviser-company-address'] + ' ' + (companyAddressModified ? modifiedClass : '')}>
          {physicalAddress}
        </div>
        <p className={styles['adviser-blurb'] + ' ' + (blurbModified ? modifiedClass : '')}>{profile.blurb}</p>
      </div>
    )
  }

  handleFirstNameChange (value) {
    this.props.setAdviserFirstName(value)
  }

  handleMiddleNameChange (value) {
    this.props.setAdviserMiddleName(value)
  }

  handleLastNameChange (value) {
    this.props.setAdviserLastName(value)
  }

  handleTitleChange (value) {
    this.props.setAdviserTitle(value)
  }

  handleCompanyChange (value) {
    this.props.setAdviserCompany(value)
  }

  handleBuildingDetailsChange (value) {
    this.props.setAdviserBuildingDetails(value)
  }

  handleStreetAddressChange (value) {
    this.props.setAdviserStreetAddress(value)
  }

  handleSuburbChange (value) {
    this.props.setAdviserSuburb(value)
  }

  handlePostalCodeChange (value) {
    this.props.setAdviserPostalCode(value)
  }

  handleCityChange (value) {
    this.props.setAdviserCity(value)
  }

  renderEditor () {
    const validationstate = this.props.isInvalid
    const profile = this.props.pendingApprovalProfile
    return <form>
      <h2 className={styles['adviser-name']}>
        {profile.firstName + ' ' + profile.lastName}
      </h2>
      <FieldGroup
        required
        value={profile.firstName}
        handleChange={this.handleFirstNameChange}
        label='First Name'
        message={validationstate?.firstName?.help}
        isInvalid={validationstate?.firstName?.isInvalid}
      />
      <FieldGroup
        value={profile.middleName || ''}
        handleChange={this.handleMiddleNameChange}
        label='Middle Name'
        message={validationstate?.middleName?.help}
        isInvalid={validationstate?.middleName?.isInvalid}
      />
      <FieldGroup
        required
        value={profile.lastName}
        handleChange={this.handleLastNameChange}
        label='Last Name'
        message={validationstate?.lastName?.help}
        isInvalid={validationstate?.lastName?.isInvalid}
      />
      <FieldGroup
        required
        value={profile.title}
        handleChange={this.handleTitleChange}
        label='Job Title'
        message={validationstate?.title?.help}
        isInvalid={validationstate?.title?.isInvalid} />
      <FieldGroup
        required
        value={profile.company}
        handleChange={this.handleCompanyChange}
        placeholder='Company'
        label='Company'
        message={validationstate?.company?.help}
        isInvalid={validationstate?.company?.isInvalid}
      />
      <FieldGroup
        value={profile.companyWebsite || ''}
        handleChange={(val) => { this.props.setAdviserCompanyWebsite(val) }}
        label='Company Website'
        message={validationstate?.companyWebsite?.help}
        isInvalid={validationstate?.companyWebsite?.isInvalid}
      />
      <FieldGroup
        value={profile.buildingDetails || ''}
        handleChange={(val) => { this.handleBuildingDetailsChange(val) }}
        label='Complex/Building details'
        message={validationstate?.buildingDetails?.help}
        isInvalid={validationstate?.buildingDetails?.isInvalid}
      />
      <FieldGroup
        required
        value={profile.streetAddress|| ''}
        handleChange={(val) => { this.handleStreetAddressChange(val) }}
        label='Street address'
        message={validationstate?.streetAddress?.help}
        isInvalid={validationstate?.streetAddress?.isInvalid}
      />
      <FieldGroup
        required
        value={profile.suburb|| ''}
        handleChange={(val) => { this.handleSuburbChange(val) }}
        label='Suburb'
        message={validationstate?.suburb?.help}
        isInvalid={validationstate?.suburb?.isInvalid}
      />
      <FieldGroup
        value={profile.postalCode|| ''}
        handleChange={(val) => { this.handlePostalCodeChange(val) }}
        label='Postal code'
        message={validationstate?.postalCode?.help}
        isInvalid={validationstate?.postalCode?.isInvalid}
      />
      <FieldGroup
        value={profile.city|| ''}
        handleChange={(val) => { this.handleCityChange(val) }}
        placeholder='City'
        label='City'
        message={validationstate?.city?.help}
        isInvalid={validationstate?.city?.isInvalid}
      />
      <FieldGroupTextArea
        required
        value={profile.blurb|| ''}
        handleChange={(val) => { this.props.setAdviserDescription(val) }}
        label='Business Description'
        message={validationstate?.businessDescription?.help}
        isInvalid={validationstate?.businessDescription?.isInvalid}
      />
    </form>
  }

  render () {
    if (this.props.editing) {
      return this.renderEditor()
    }
    return this.renderPreview(this.props.pendingApprovalProfile, this.props.publishedProfile)
  }
}

const mapStateToProps = ({ adviserProfileApprovalEditorContainer }) => {
  return {
    editing: adviserProfileApprovalEditorContainer.blurb.editingBlurb,
    loading: adviserProfileApprovalEditorContainer.blurb.loadingBlurb,
    formIsValid: adviserProfileApprovalEditorContainer.blurb.isInvalid.formIsValid,
    validationstate: adviserProfileApprovalEditorContainer.blurb.isInvalid,
    editingProfile: adviserProfileApprovalEditorContainer.editingProfile
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    startEditing: startEditingBlurb,
    stopEditing: stopEditingBlurb,
    setAdviserFirstName: setAdviserFirstName,
    setAdviserMiddleName: setAdviserMiddleName,
    setAdviserLastName: setAdviserLastName,
    setAdviserTitle: setAdviserTitle,
    setAdviserCompany: setAdviserCompany,
    setAdviserBuildingDetails: setAdviserBuildingDetails,
    setAdviserStreetAddress: setAdviserStreetAddress,
    setAdviserSuburb: setAdviserSuburb,
    setAdviserPostalCode: setAdviserPostalCode,
    setAdviserCity: setAdviserCity,
    setAdviserCompanyWebsite: setAdviserCompanyWebsite,
    setAdviserDescription: setAdviserDescription,
    cancelEditingAdviserProfileBlurb: cancelEditingAdviserProfileBlurb
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PendingApprovalAdviserProfileBlurbEditor)
